export const tutorConfig = {
    id: 'tutor',
    initial: 'draft',
    states: {
        draft: {
            on: { ACTIVATE: { target: 'active', guard: 'hasValidQualifications' } },
        },
        active: {
            on: {
                SUSPEND: { target: 'suspended', guard: 'hasSuspensionReason' },
                DEACTIVATE: { target: 'deactivated' },
            },
        },
        suspended: {
            on: {
                ACTIVATE: { target: 'active', guard: 'hasValidQualifications' },
                DEACTIVATE: { target: 'deactivated' },
            },
        },
        deactivated: {
            on: {
                ACTIVATE: { target: 'active', guard: 'hasValidQualifications' },
            },
        },
    },
};
//# sourceMappingURL=tutor.js.map